(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("FacetFiltersForm");
    if (!form) return;

    form.addEventListener("change", function () {
      form.submit();
    });

    const filtersTrigger = document.querySelector(".filters-trigger");
    const filtersPanel = document.querySelector(".collection__sidebar__filters");

    if (filtersTrigger && filtersPanel) {
      filtersTrigger.addEventListener("click", function () {
        filtersPanel.classList.toggle("collection__sidebar__filters--active");
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const navigationHeaders = document.querySelectorAll('.footer__navigation__header');
    
    navigationHeaders.forEach(header => {
        header.addEventListener('click', function() {
            const navigation = this.parentElement;
            navigation.classList.toggle('footer__navigation--open');
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
// Header Height
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.sticky-header');
  if (!header) return;

  const update = () => {
    document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
  };

  const ro = new ResizeObserver(update);
  ro.observe(header);

  update();
});

// Open and close navigation
const header = document.querySelector('.header');
const hamburger = document.querySelector('.header__hamburger');
const closeButton = document.querySelector('.header__close');

hamburger.addEventListener('click', function() {
  if(!header.classList.contains('header--open')) {
    header.classList.add('header--open');
  }
});
closeButton.addEventListener('click', function() {
  header.classList.remove('header--open');
});


// Scroll handling
let lastScrollPosition = 0;
let isScrollingDown = false;
const scrollThreshold = 10;

function handleScroll() {
  const currentScrollPosition = window.scrollY;
  const scrollDelta = currentScrollPosition - lastScrollPosition;

  if (currentScrollPosition > 200) {
    document.body.classList.add('scrolled');

    if (scrollDelta > scrollThreshold) {
      document.body.classList.remove('scrolled--up');
      document.body.classList.add('scrolled--down');
      isScrollingDown = true;
    } else if (scrollDelta < -scrollThreshold) {
      document.body.classList.remove('scrolled--down');
      document.body.classList.add('scrolled--up');
      isScrollingDown = false;
    }
  } else {
    document.body.classList.remove('scrolled', 'scrolled--down', 'scrolled--up');
  }

  lastScrollPosition = currentScrollPosition;
}

document.addEventListener('DOMContentLoaded', () => {
  handleScroll();
  window.addEventListener('scroll', handleScroll);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const track = document.getElementById("logoMarqueeTrack");
  const wrapper = document.getElementById("logoMarqueeWrapper");
  const marquee = document.querySelector(".logo-marquee");

  if (!track || !wrapper || !marquee) return;

  const originalItems = Array.from(track.children);
  if (originalItems.length > 0) {
    const originalContent = track.innerHTML;
    track.innerHTML = originalContent;

    const wrapperWidth = wrapper.offsetWidth;
    let trackWidth = track.scrollWidth;

    if (trackWidth < wrapperWidth * 2) {
      const multiplier = Math.ceil((wrapperWidth * 2) / trackWidth);
      for (let i = 0; i < multiplier; i++) {
        track.innerHTML += originalContent;
      }
    }
    trackWidth = track.scrollWidth;

    const pixelsPerSecond = 100;
    const duration = trackWidth / pixelsPerSecond;

    track.style.animationDuration = `${duration}s`;
  }

  marquee.classList.add("logo-marquee--ready");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 300px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subheader-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const dropdownItems = document.querySelectorAll('.subheader__nav-item.with-dropdown');
  const isTouchDevice = window.matchMedia('(hover: none)').matches;

  dropdownItems.forEach(item => {
    const trigger = item.querySelector('.subheader__nav-link');

    if (isTouchDevice) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const isOpen = item.classList.contains('with-dropdown--open');

        if (isOpen) {
          item.classList.remove('with-dropdown--open');
          return;
        }

        dropdownItems.forEach(i => i.classList.remove('with-dropdown--open'));
        item.classList.add('with-dropdown--open');
      });

      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) {
          item.classList.remove('with-dropdown--open');
        }
      });
    } else {
      let openTimeout, closeTimeout;

      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimeout);
        openTimeout = setTimeout(() => {
          dropdownItems.forEach(i => i.classList.remove('with-dropdown--open'));
          item.classList.add('with-dropdown--open');
        }, 125);
      });

      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimeout);
        closeTimeout = setTimeout(() => {
          item.classList.remove('with-dropdown--open');
        }, 125);
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
